import type { Currency } from '@weft/types';
import React from 'react';
import { NoItemsIcon } from '../../../../../../components/icons/NoItemsIcon';
import { LivePreviewContainer } from './LivePreviewContainer';

type EmptyLivePreviewProps = {
  title: React.ReactNode;
  currency: Currency;
  itemsCount: number;
  totalAmount: number;
  onHide?: () => void;
};

export const EmptyLivePreview: React.FC<EmptyLivePreviewProps> = ({ title, currency, itemsCount, totalAmount, onHide }) => {
  return (
    <LivePreviewContainer
      currency={currency}
      itemsCount={itemsCount}
      totalAmount={totalAmount}
      onHide={onHide}
      title={title}
    >
      <div className="m-auto flex h-full w-full flex-col items-center justify-center pb-10">
        <NoItemsIcon/>
        <span className="text-lg font-normal leading-6 text-[#111B1E]">No Items Yet</span>
        <span className="text-sm font-light leading-5 text-[#9DA8AC]">your items will appear here</span>
      </div>
    </LivePreviewContainer>
  );
};